module.exports = require('./helpers/bundle-url').getBundleURL('AyoAQ') + "logo-dark.eefe0b7f.svg";